import { createExporter } from "utils/createExporter";
import { parseDateTime } from "server/datetimeUtils";
import { EmailRequestStatus } from "utils/choices";
import { EMAILS } from "utils/constants";

export const SentEmailsExporter = createExporter(
  `notification_sent_${EMAILS}.xlsx`,
  [
    { key: "sentOn", label: "изпратен на" },
    { key: "status", label: "статус" },
  ],
  record => ({
    sentOn: parseDateTime(record.sentOn),
    status: EmailRequestStatus[record.id],
  }),
);
